import Quill from 'quill'

import BaseAdsBannerBlot from './base_banners'

export class AdsBannerHorizontalBlot extends BaseAdsBannerBlot {
  static getBannerType() {
    return 'horizontal'
  }
}

export function initBannersAdsBannerHorizontal() {
  const icons = Quill.import('ui/icons')
  icons['banner-horizontal'] =
    '<div class="icon-banner-horizontal">Horizontal banner</div>'

  AdsBannerHorizontalBlot.blotName = 'banner-horizontal'
  AdsBannerHorizontalBlot.tagName = 'div'
  AdsBannerHorizontalBlot.className = 'ads-banner__container'

  Quill.register(AdsBannerHorizontalBlot)
}
